import Vue from 'vue'
import API from '@/service/api'

const state = {
  storageEntries: [],
  storageTypesEntries: [],
}

const mutations = {
  UPDATE_STORAGE_ENTRIES(state, payload) {
    state.storageEntries = payload
  },
  UPDATE_SINGLE_STORAGE(state, updatedStorage) {
    const index = state.storageEntries.findIndex(s => s.id === updatedStorage.id)
    if (index !== -1) {
      Vue.set(state.storageEntries, index, updatedStorage)
    }
  },
  UPDATE_STORAGE_TYPES_ENTRIES(state, payload) {
    state.storageTypesEntries = payload
  },
}

const actions = {
  getStorageEntries({ commit }) {
    return API()
      .get('/storages')
      .then(response => {
        commit('UPDATE_STORAGE_ENTRIES', response.data)
        return response.data
      })
      .catch(error => {
        console.log('Error: getStorageEntries')
        console.log(error)
        return error
      })
  },

  addStorage({ commit }, payload) {
    return API()
      .post('/storages', payload)
      .then(response => {
        commit('UPDATE_STORAGE_ENTRIES', response.data)
        return response.data
      })
      .catch(error => error)
  },
  deleteStorage({ commit }, id) {
    return API()
      .delete(`/storages/${id}`)
      .then(response => {
        commit('UPDATE_STORAGE_ENTRIES', response.data)
        return response.data
      })
      .catch(error => error)
  },
  updateStorage({ commit }, payload) {
    return (
      API()
        .put(`/storages/${payload.id}`, payload)
        .then(response => {
          commit('UPDATE_SINGLE_STORAGE', response.data)
          return response.data
        })
        .catch(error => error)
    )
  },

  getStorageTypesEntries({ commit }) {
    return API()
      .get('/storage-types')
      .then(response => {
        commit('UPDATE_STORAGE_TYPES_ENTRIES', response.data)
        return response.data
      })
      .catch(error => error)
  },

  addStorageType({ commit }, payload) {
    return API()
      .post('/storage-types', payload)
      .then(response => {
        commit('UPDATE_STORAGE_TYPES_ENTRIES', response.data)
        return response.data
      })
      .catch(error => error)
  },

  deleteStorageType({ commit }, id) {
    return API()
      .delete(`/storage-types/${id}`)
      .then(response => {
        commit('UPDATE_STORAGE_TYPES_ENTRIES', response.data)
        return response.data
      })
      .catch(error => error)
  },

  updateStorageType({ commit }, payload) {
    return API()
      .put(`/storage-types/${payload.id}`, payload)
      .then(response => {
        commit('UPDATE_STORAGE_TYPES_ENTRIES', response.data)
        return response.data
      })
      .catch(error => error)
  },
}

const getters = {
  storageEntries: state => state.storageEntries,
  storageById: state => id =>
    state.storageEntries.find(storageEntry => storageEntry.id === id),
  getStorageTypes: state => state.storageTypesEntries,
  getStorageTypesById: state => id =>
    state.storageTypesEntries.find(storageType => storageType.id === id),
  getAllStorageFromLocationId: state => id =>
    state.storageEntries
      .filter(storageEntry => storageEntry.location.id === id)
      .sort((a, b) => b.id - a.id),
  getAllStorageFromOfferId: state => id =>
    state.storageEntries
      .filter(storageEntry => storageEntry.offer.id === id)
      .sort((a, b) => b.id - a.id),
}

const storageModule = {
  state,
  mutations,
  actions,
  getters,
}

export default storageModule
